import { useQuery } from '@apollo/client/react';
import { Grid } from '@mui/material';
import { map } from 'lodash';
import React, { useState } from 'react';

import CreateNoteModal from './CreateNoteModal';
import DrawerFilters from './DrawerFilters';
import NoteCard from './NoteCard';

import { type GetPersonalNotesQuery, GetPersonalNotesDocument } from '@/graphql/generated/graphql';

const DEFAULT_FILTERS = {
  search: '',
  noteType: '',
  tagIds: [],
};

const DrawerNotes: React.FC = () => {
  const [currentNote, setCurrentNote] = useState<NonNullable<GetPersonalNotesQuery['getPersonalNotes']>[0] | null>(
    null,
  );
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const { data } = useQuery(GetPersonalNotesDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      ...Object.fromEntries(Object.entries(filters).filter(([_, value]) => value !== '')),
    },
  });

  return (
    <React.Fragment>
      <DrawerFilters
        filters={filters}
        onChange={(key, value) => {
          setFilters((prev) => ({
            ...prev,
            [key]: value,
          }));
        }}
      />
      <Grid container alignContent="flex-start" size={12}>
        {map(data?.getPersonalNotes, (note, index) => (
          <NoteCard note={note} onClick={() => setCurrentNote(note)} key={`notes-list-${note.id}-${index}`} />
        ))}
      </Grid>
      {currentNote && <CreateNoteModal handleClose={() => setCurrentNote(null)} currentNote={currentNote} />}
    </React.Fragment>
  );
};

export default DrawerNotes;
